import React, { useCallback, useMemo, useState } from 'react';
import { Box, Checkbox, Dropdown, Option, OptionKey, Text } from '@common-fe/common-fe';

import { ALL_KEY } from '@/common/constants';

interface Props {
  options: Option[];
  values: OptionKey[];
  onChangeValues: (values: OptionKey[]) => void;
}
const MoneyTransferStatusSelect: React.FC<Props> = ({ options, values, onChangeValues }) => {
  const [isExpanded, setExpanded] = useState(false);

  const currentTitle = useMemo(() => {
    if (values.length) {
      return values.map((value) => options.find((option) => option.key === value)?.title).join(', ');
    }
    return 'All';
  }, [options, values]);
  const handleToggleValue = useCallback(
    (key: string) => {
      let list = [...values];
      if (key === ALL_KEY) {
        onChangeValues([ALL_KEY]);
        return;
      } else {
        list = list.filter((key) => key !== ALL_KEY);
      }
      if (list.includes(key)) {
        list = list.filter((item) => item !== key);
      } else {
        list = [...list, key];
      }
      onChangeValues(list);
    },
    [onChangeValues, values]
  );
  return (
    <Box width="240px">
      <Dropdown
        placeholder="Placeholder"
        isClickOutside={true}
        testId="money-transfer_select"
        prefix="Status"
        expanded={isExpanded}
        title={
          <Text title={currentTitle} color="textAccent" truncate>
            {currentTitle}
          </Text>
        }
        onSetExpanded={setExpanded}
      >
        <Box direction="column" data-testid="" pad="s">
          {options.map((item) => (
            <Box key={item.key} pad={{ horizontal: 'xs', vertical: 'xxs' }}>
              <Checkbox
                name={`${item.key}`}
                testId="money-transfer_select"
                checked={values.includes(item.key)}
                onChange={() => handleToggleValue(item.key as string)}
              >
                <Text>{item.title}</Text>
              </Checkbox>
            </Box>
          ))}
        </Box>
      </Dropdown>
    </Box>
  );
};

export default MoneyTransferStatusSelect;
